<template> 
  <div id="action" class="action">
  <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
    <button class="badge badge-info" @click="userDetail()"><i class="material-icons">remove_red_eye</i></button>
    <!-- <button class="badge badge-secondry" @click="editUser()"><i class="material-icons">edit</i></button> -->
    <button v-if="row.status === 'active'" class="badge badge-secondry editBtn" id="editBtn" v-on:click="editUser()"><i class="material-icons editBtn">edit</i></button>
    <button class="badge badge-danger"  v-confirm="{ loader: false, ok: deleteUser, message: 'Do you really want to delete?'}"><i class="material-icons">delete</i></button>
  </div>

</template>
<script>
  import axios from 'axios'
  import EditUserModal from './EditUserModal.vue'
  import User from './User.vue'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'action',
    props: ['row', 'data'],
    components: { User,
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        users: [],
        errors: [],
        password: '',
        cnfpassword: '',
        userDetails: {
          name: '',
          username: '',
          email: '',
          uid: ''
        },
        errormessage: ''
      }
    },
    methods: {
      deleteUser () {
        var jwttoken = localStorage.getItem('jwt')
        console.log(this.row.uid)
        let uid = this.row.uid
        let subsId = this.row.stripe_subscription_id
          this.isLoading = true
          axios.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deactivateUser' + '?' + 'user_id' + '=' + uid + '&' + 'stripe_subscription_id' + '=' + subsId, {
            headers: {
              'x-access-token': jwttoken
            }})
          .then(response => {
               this.isLoading = false
               this.$eventBus.$emit('listUser', 'User is deleted successfully');
            }).catch(function(error) {
               this.isLoading = false
               this.$eventBus.$emit('listUser', '','User could not be deleted');
            });
      },
      userDetail () {
       let location = '/userDetail' + '/' + this.row.uid + '/' + 'userlistpage'
        this.$router.push(location);

      },
      editUser () {
        var jwttoken = localStorage.getItem('jwt')
        let uid = this.row.uid
        this.isLoading = true
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById' + '?' + 'uid' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            this.$modal.show(EditUserModal, { userDetails: response.data.results[0] }, { height: '100%' })
          })
          .catch((error) => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Action.vue